var userEntry ={
    email: " ", firstName: " ", lastName:" ", gender: " ", phone: " ", bio:" "
    }
export default userEntry;
